import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useId } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field } from 'src/shared/components/form/field';
export function Name() {
    const { formState, register } = useFormContext();
    const inputId = useId();
    const { t } = useTranslation();
    return (_jsxs(Field, { className: "mb-4 lg:mb-6", invalid: Boolean(formState.errors.name?.message), invalidMessage: formState.errors.name?.message, children: [_jsxs(Field.Label, { className: "mb-2", htmlFor: inputId, children: [t('content.form.title'), " *"] }), _jsx("input", { id: inputId, maxLength: 255, placeholder: t('content.form.title_placeholder'), invalid: !formState.errors.name?.message ? undefined : 'true', ...register('name') })] }));
}
